export default __webpack_public_path__ + "static/media/24.badc8da1.mp3";